import script from "./CompanyConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./CompanyConfiguration.vue?vue&type=style&index=0&id=6fb07004&scoped=true&lang=css"

import exportComponent from "C:\\www\\mutual-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb07004"]])

export default __exports__